export const LAB_STATS = [
  { value: "2", label: "doctoral graduated, three in progress" },
  { value: "15", label: "Master's theses completed, two ongoing" },
  { value: "30", label: "undergraduate theses" },
  { value: "1", label: "postdoctoral researcher, 2024 to 2025" },
];

export const LAB_DOES = [
  {
    title: "You will build something that runs",
    body: "The lab employs developers, so a concept becomes a working artefact rather than a specification. Nothing here is evaluated as a mock-up.",
  },
  {
    title: "You will meet the users",
    body: "Teachers, health workers and consumers shape the work directly. The user population sets the vocabulary, it is not assumed.",
  },
  {
    title: "You will measure honestly",
    body: "Pre-test, post-test, delayed retention, operational timing. The non-significant module is published alongside the significant one.",
  },
  {
    title: "Equipment is not the bottleneck",
    body: "Meta Quest 2, 3, 3S and Quest Pro, HoloLens, Magic Leap, 360 degree cameras, VR-ready workstations.",
  },
];

export const PEOPLE = [
  {
    name: "Pranjal Borah",
    role: "PhD, defended December 2023",
    thesis: "Design and Evaluation of Naamya: a bend-gesture tool for drawing primitive geometric shapes for users with blindness or low vision",
    photo: "/images/portrait-pranjal.png",
  },
  {
    name: "Priya Ganapathy",
    role: "PhD, defended December 2023",
    thesis: "Design and Evaluation of User-Centric Gestures for Locomotion in HMD-VR Interfaces for a Seated Position",
    photo: "/images/portrait-priya.jpeg",
  },
  {
    name: "Rishabh Pandey",
    role: "PhD candidate, since 2022",
    thesis: "Three-dimensional body-referenced menu design for virtual reality",
    photo: "/images/portrait-rishabh.jpeg",
  },
  {
    name: "Dr Nilotpal Biswas",
    role: "Postdoctoral researcher, 2024 to 2025",
    thesis: "Accessible immersive retail for partially sighted consumers, on the Walmart project",
    photo: "/images/portrait-nilotpal.jpeg",
  },
];

export const PEOPLE_NOTE =
  "Two further doctoral students and two Master's students, Rajeswari Sundi and Sharon Samson, are currently in progress. Names and thesis titles are added here as each is confirmed.";

export const RECRUITING_BLURB =
  "If one of these is the thing you want to spend a few years on, write to me with a paragraph on why, and what you would build first. Do not send a generic enquiry.";

export const STUDENT_AWARDS = [
  "CII Design Award, Interaction Design category, 2016",
  "Gandhian Young Technological Innovation Award for ProjectTB, 2015",
  "Gandhian Young Technological Innovation Award for Chetna, 2011",
];
